import { forkJoin, Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import State from '../../../application/core/State';
import api from '../../core/api';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import RequestFailed from '../../core/events/RequestFailed';
import EstimationsRequested from '../events/EstimationsRequested';
import EstimationsRequestSucceed from '../events/EstimationsRequestSucceed';
import EstimationPeriod from '../../../domain/EstimationPeriod';
import Estimations from '../../../domain/estimations/Estimations';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import { AjaxError } from 'rxjs/internal/observable/dom/AjaxObservable';

interface CurrentEstimationPeriodResponse {
    response: EstimationPeriod;
}

interface EstimationsResponse {
    response: Estimations;
}

// todo test this epic
export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(EstimationsRequested.type),
        mergeMap(() =>
            backend.get(`${api()}estimation-periods`).pipe(
                mergeMap((currentEstimationPeriodResponse: CurrentEstimationPeriodResponse) => {
                    const urls = [
                        `${api()}users/${state$.value.user.customerId}/estimations/draft`,
                        `${api()}users/${state$.value.user.customerId}/estimations`
                    ];
                    const call = (url: string): Observable<EstimationsResponse> =>
                        backend.post(url, JSON.stringify(currentEstimationPeriodResponse.response.months));
                    return forkJoin(urls.map((url: string) => call(url))).pipe(
                        map((response: EstimationsResponse[]) => {
                            return new EstimationsRequestSucceed(
                                currentEstimationPeriodResponse.response,
                                response[0].response,
                                response[1].response
                            );
                        })
                    );
                }),
                catchError((e: AjaxError) => of(new RequestFailed(e.status)))
            )
        )
    );



// WEBPACK FOOTER //
// ./src/application/estimations/epic/estimationsDraftGet.ts